import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { getTool } from "./tools";
import { ToolLayout } from "./ToolLayout";
import { LazyWidget } from "./LazyWidget";
import { widgetLoaders } from "./widgets";
import { NotFound } from "../pages/NotFound";

export function ToolPage() {
  const { slug } = useParams<{ slug: string }>();
  const tool = slug ? getTool(slug) : undefined;
  const loader = slug ? widgetLoaders[slug] : undefined;

  // Hooks must run unconditionally; the loader is stable per slug.
  const load = useCallback(() => {
    if (!loader) return Promise.reject(new Error("no widget"));
    return loader();
  }, [loader]);

  if (!tool || !loader) return <NotFound />;

  return (
    <ToolLayout tool={tool}>
      <LazyWidget load={load} />
    </ToolLayout>
  );
}
